/* eslint-disable @typescript-eslint/no-unnecessary-condition -- dd is weird... */
import { datadogLogs } from "@datadog/browser-logs";
import { logsConfig } from "../providers/datadog/config";

class DatadogLogger {
  private static instance: DatadogLogger;

  private constructor() {
    if (!datadogLogs.getInitConfiguration()) datadogLogs.init(logsConfig);
  }

  static getInstance(): DatadogLogger {
    if (!DatadogLogger.instance) DatadogLogger.instance = new DatadogLogger();
    return DatadogLogger.instance;
  }

  info(message: string, context?: unknown) {
    document &&
      datadogLogs.logger.info(
        message,
        context
          ? {
              payload: context
            }
          : undefined
      );
  }

  warn(message: string, context?: unknown) {
    document &&
      datadogLogs.logger.warn(
        message,
        context
          ? {
              payload: context
            }
          : undefined
      );
  }

  error(message: string, context?: unknown) {
    document &&
      datadogLogs.logger.error(
        message,
        context
          ? {
              payload: context
            }
          : undefined
      );
  }
}

export const logger = DatadogLogger.getInstance();
